import type { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import styles from './InstallButton.module.css';

interface InstallButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  onClick: () => void;
}

export const InstallButton = ({
  onClick,
  className = '',
  ...props
}: InstallButtonProps) => {
  const { t } = useTranslation();
  const classNames = [styles.installButton, className].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classNames}
      onClick={onClick}
      aria-label={t('install.installApp')}
      title={t('install.installApp')}
      {...props}
    >
      <Download className={styles.icon} size={24} />
    </button>
  );
};

